import Icon from '../icon/Icon';
import './ColorGridPicker.less';

type ColorGridPickerItem = {
    id: string;
    color?: string;
    label: string;
};

export type ColorGridPickerProps = {
    availableColors: (ColorGridPickerItem & {
        isSelected: boolean;
    })[];
    onItemClick: (item: ColorGridPickerItem) => void;
};

const ColorGridPicker = ({
    availableColors,
    onItemClick
}: ColorGridPickerProps) => {
    const getContrastColor = (
        hexcolor: string = '',
        luminanceLimitPercentage: number
    ) => {
        // Remove the hash at the start if it's there
        hexcolor = hexcolor.replace('#', '');

        // Parse the r, g, b values
        const r = parseInt(hexcolor.substring(0, 2), 16);
        const g = parseInt(hexcolor.substring(2, 4), 16);
        const b = parseInt(hexcolor.substring(4, 6), 16);

        // Calculate the luminance. It should be a value between 0 and 255
        const luminance = Math.sqrt(
            0.299 * Math.pow(r, 2) +
                0.587 * Math.pow(g, 2) +
                0.114 * Math.pow(b, 2)
        );

        // Return black or white based on luminance
        return luminance > (luminanceLimitPercentage / 100) * 255
            ? '#000'
            : '#fff';
    };
    return (
        <div className={`bri-ColorGridPicker bri-Body2Font`}>
            {availableColors.map(color => (
                <div
                    tabIndex={0}
                    key={color.id}
                    className={`bri-ColorGridPicker-item ${
                        color.isSelected ? 'bri-selected' : ''
                    }${color.isSelected ? ' bri-Body2BoldFont' : ''}`}
                    style={{
                        '--bri-contrast-color': getContrastColor(
                            color.color,
                            98
                        ),
                        '--bri-icon-contrast-color': getContrastColor(
                            color.color,
                            70
                        )
                    }}
                    onClick={() => {
                        onItemClick({
                            color: color.color,
                            id: color.id,
                            label: color.label
                        });
                    }}
                >
                    <div
                        className="bri-ColorGridPicker-item-color"
                        style={{
                            background: `${color.color} content-box`
                        }}
                    >
                        {color.isSelected && (
                            <Icon iconId="check" size="medium" />
                        )}
                    </div>
                    {color.label}
                </div>
            ))}
        </div>
    );
};

export default ColorGridPicker;
